/* UncommonSmart: confirm size before the first add-to-cart (2026-10-07).
   Minimog pre-fills the first size (often XXS). Custom-made suits cannot be returned, so the first
   tap on Add to cart (main form or mobile sticky bar) without a size interaction scrolls to the size
   row and asks the shopper to confirm. A second tap always proceeds. */
(() => {
  let confirmed = false;
  let nudged = false;
  const isSize = (field) => /size/i.test(field?.dataset.optionName || '');
  const mainInfo = () => document.querySelector('product-info[id^="MainProduct"]');
  const sizeField = () => [...(mainInfo()?.querySelectorAll('[data-picker-field]') || [])].find(isSize);

  const markIfSize = (e) => {
    const field = e.target.closest?.('[data-picker-field]');
    if (field && isSize(field) && field.closest('product-info[id^="MainProduct"]')) confirmed = true;
  };
  document.addEventListener('change', markIfSize, true);
  document.addEventListener('click', markIfSize, true);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('button[name="add"]');
    if (!btn || confirmed || nudged || btn.disabled) return;
    if (!btn.closest('product-info[id^="MainProduct"], sticky-atc')) return;
    const field = sizeField();
    if (!field) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    nudged = true;
    const current = field.querySelector('.option-label--selected')?.textContent.trim();
    let note = field.querySelector('.uncommon-size-confirm');
    if (!note) {
      note = document.createElement('p');
      note.className = 'uncommon-size-confirm';
      note.setAttribute('role', 'alert');
      field.appendChild(note);
    }
    note.textContent = current
      ? `Please confirm your size. ${current} is selected — tap your size, or tap Add to cart again to keep ${current}.`
      : 'Please choose your size first.';
    field.classList.add('uncommon-size-attention');
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);
})();
